// 实物商品订单
const UrlName = '/order/v1';
export default API => ({
    createdOrder(data) {
        return API({ url: `${UrlName}/open/order/mall/placeOrder`, method:'post', data });
    },
    getOrderDetail(params) {
        return API({ 
            url: `${UrlName}/open/order/getOrderByNo`,
            params
        });
    },
    getSelectEntityGoods(params) {
        return API({ 
            url: `${UrlName}/open/order/getSelectEntityGoods?uuid=${params.uuid}`,
        });
    },
    getAddressInfo(params) {
        return API({ 
            url: `${UrlName}/open/order/getOrderByNo`,
            params
        });
    },
    getDdeliveryDetail(params) {
        return API({ 
            url: `${UrlName}/open/order/deliveryDetail`,
            params
        });
    },
    confirmDeliverSuccess(params) {
        return API({ 
            url: `${UrlName}/open/order/confirmDeliverSuccess`,
            params
        });
    },
    cancelOrder(params) {
        return API({ 
            url: `${UrlName}/open/order/mall/cancelOrder`,
            method:'post',
            params
        });
    },
    
  })
  